import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Condition } from "@/keyboard";
import { ConditionTypeLogic, isCondLogic } from "@/keyboard/leds";
import ConditionTypeButton from "@/components/leds/ConditionTypeButton.vue";
import ConditionLogicEdit from "@/components/leds/ConditionLogicEdit.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionEdit',
  props: {
    modelValue: {},
    parentLogic: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (!_unref(isCondLogic)(_ctx.modelValue))
    ? (_openBlock(), _createBlock(ConditionTypeButton, {
        key: 0,
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (c) => _ctx.$emit('update:modelValue', c)),
        parentLogic: _ctx.parentLogic
      }, null, 8, ["modelValue", "parentLogic"]))
    : (_openBlock(), _createBlock(ConditionLogicEdit, {
        key: 1,
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = (c) => _ctx.$emit('update:modelValue', c)),
        parentLogic: _ctx.parentLogic
      }, null, 8, ["modelValue", "parentLogic"]))
}
}

})